import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { linkFoodDetail } from '../../util/util';

import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './MultiFoodResultTable.css';

const alignCenter = {
  thStyle: {textAlign: 'center'},
  tdStyle: {textAlign: 'center'},
};

const createCsvData = tableData => {
  const csvData = tableData.map(row => {
    return (row.category && row.level)
      ? {category: '  ' + row.category}
      : row.category
        ? {category: row.category}
        : row;
  });
  return csvData;
};

const setIndentClass = (cell, row) => row.indent ? 'indent' : '';
const rowClassNameFormat = (row) => {
  let className = row.subheader ? 'subheader' : '';
  className += row.level ? `-${row.level}` : '';
  return className;
};

class MultiFoodResultTable extends Component {
  componentDidMount() {
    const csvData = createCsvData(this.props.tableData);
    this.props.setCsvData(csvData);
  }

  // This works when selected foods are reduced.
  componentWillReceiveProps(nextProps) {
    if(this.props.tableData !== nextProps.tableData) {
      const csvData = createCsvData(nextProps.tableData);
      this.props.setCsvData(csvData);
    }
  }

  getAmountString(selectedFood, thisSelectedReport, isPer100g){

      if(isPer100g){
          return "100 g";
      }else{
          return selectedFood.serving_size_value + " " +
            selectedFood.serving_size_unit
      }
  }



  render() {
    const { tableType, tableData, selectedFoods, selectedReport, per100g } = this.props;

    return (
      <div className={'MultiFoodResultTable' + (tableType ? ` ${tableType}` : '')}>

        <BootstrapTable
          data={tableData}
          hover
          condensed
          bordered={false}
          trClassName={rowClassNameFormat}>

          {(tableType === 'fullGrouped' || tableType === 'basic')&&
            <TableHeaderColumn
              dataField='category'
            >
              CATEGORY
            </TableHeaderColumn>
          }

          <TableHeaderColumn
            isKey
            dataField='nutrient'
            columnClassName={setIndentClass}
          >
          NUTRIENT</TableHeaderColumn>

          <TableHeaderColumn
            dataField='unit'
            {...alignCenter}
          >
          UNIT</TableHeaderColumn>

          <TableHeaderColumn
            dataField='food1'
            headerText={selectedFoods[0].shortname}
            {...alignCenter}
          >
          {linkFoodDetail(selectedFoods[0].shortname.toUpperCase(),
                          selectedFoods[0],
                           selectedReport)}
           <br/>
          {this.getAmountString(selectedFoods[0],selectedReport, per100g)}


          </TableHeaderColumn>

          {selectedFoods[1] &&
            <TableHeaderColumn
              dataField='food2'
              headerText={selectedFoods[1].shortname}
              {...alignCenter}
            >
              {linkFoodDetail(selectedFoods[1].shortname.toUpperCase(),
                              selectedFoods[1],
                              selectedReport)}
              <br/>
             {this.getAmountString(selectedFoods[1],selectedReport, per100g)}
            </TableHeaderColumn>
          }

          {selectedFoods[2] &&
            <TableHeaderColumn
              dataField='food3'
              headerText={selectedFoods[2].shortname}
              {...alignCenter}
            >
              {linkFoodDetail(selectedFoods[2].shortname.toUpperCase(),
                              selectedFoods[2],
                               selectedReport)}
              <br/>
              {this.getAmountString(selectedFoods[2],selectedReport, per100g)}
            </TableHeaderColumn>
          }
        </BootstrapTable>

      </div>
    );
  }
}

MultiFoodResultTable.propTypes = {
  tableType: PropTypes.string,
  tableData: PropTypes.array,
  selectedFoods: PropTypes.array,
  selectedReport: PropTypes.string,
  setCsvData: PropTypes.func.isRequired,
};

export default MultiFoodResultTable;



// WEBPACK FOOTER //
// ./src/components/search/multiFood/MultiFoodResultTable.js